<template>
  <one-column-layout :loading="false">

    <title-bar :title="title" slot="titleBar">
      <div class="smd-spacer"/>

      <smd-btn icon="smd-icon-action-close" @click="close"/>
    </title-bar>

    <two-column-layout class="sb-min-180 hide-sidebar">
      <title-bar class="space-s-l" type="page" slot="sidebar">
        <smd-btn clean class="icon-text" @click="back">
          <i class="smd-icon-arrow-left"/>
          <label dark-normal>Back</label>
        </smd-btn>
      </title-bar>


      <div class="flex-center" slot="content">

        <one-column-layout class="space-l max-1000">
          <title-bar title="User Information" type="page" slot="titleBar">
            <div class="smd-spacer"/>
            <smd-btn @click.prevent="saveUserInfo">Save</smd-btn>
          </title-bar>

          <div class="form new-patient">
            <div>
              <div class="smd-profile-image xl"></div>
              <smd-btn clean><label>Add Photo</label></smd-btn>
            </div>
            <div>
              <div class="form__row--x">
                <label>First Name</label>
                <input type="text" placeholder="e.g. John" v-model="firstname">
              </div>
              <div class="form__row--x">
                <label>Last Name</label>
                <input type="text" placeholder="e.g. Doe"  v-model="lastname">
              </div>
              <div class="form__row--x">
                <label>Username</label>
                <input type="text" placeholder="e.g. jd0123"  v-model="username">
              </div>
              <div class="form__row--x">
                <label>Role</label>
                <select v-model="role">
                  <option v-for="roleName in roleNames"
                          :value="roleName.name"
                          :key="roleName._id">
                    {{ roleName.label}}
                  </option>
                </select>
              </div>
              <div class="form__row" v-if="isForEdit">
                <button @click="isReset=!isReset">{{isReset? 'CANCEL':'RESET PASSWORD'}}</button>
              </div>
              <div class="form__row--x" v-if="!isForEdit || isReset">
                <label>Password</label>
                <input type="password" placeholder="*********"  v-model="password">
              </div>
            </div>
          </div>
        </one-column-layout>

      </div>

    </two-column-layout>

  </one-column-layout>
</template>

<script>
  import { tap  } from 'rxjs/operators';
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { MUTATE_SHOW_OVERLAY } from '../../../store/modules/shared'
  import {
    ACTION_ADD_USER,
    ACTION_EDIT_USER,
    GETTER_SELECTED_USER,
    ACTION_LOAD_SELECTED_USER
  } from '../../../store/modules/admin'
  import Routes from '../../../router/route-constants'

  import {apiLoadRoleNames} from '../../../store/api/apiObservables'

  export default {
    data(){
      return{
        firstname  : null,
        lastname   : null,
        username   : null,
        password   : null,
        role       : null,
        isReset    : false,
        roleNames  : []
      }
    },
    computed: {
      ...mapGetters({
        user: GETTER_SELECTED_USER
      }),
      isForEdit(){
        return this.$route.name === Routes.ROUTE_EDIT_USER;
      },
      title(){
        return this.isForEdit ? "Edit User" : "Add User"
      }
    },
    methods:{
      ...mapMutations({
        showOverlay: MUTATE_SHOW_OVERLAY
      }),
      ...mapActions({
        addUser : ACTION_ADD_USER,
        editUser: ACTION_EDIT_USER,
        loadSelectedUser : ACTION_LOAD_SELECTED_USER
      }),
      saveUserInfo(){
        let data = {
          userid    : this.$route.params.userid,
          firstname : this.firstname,
          lastname  : this.lastname,
          username  : this.username,
          role      : this.role,
          password  : this.password
        };

        let promise = this.isForEdit ? this.editUser(data) : this.addUser(data);
        promise.then(()=>{
          this.afterSave()
        })
      },
      back(){
        this.showOverlay(false);
        this.$router.push({name: Routes.ROOT_ROUTE_ADMIN});
      },
      close(){
        this.showOverlay(false);
        this.$router.push({name: Routes.ROOT_ROUTE_ADMIN});
      },
      afterSave(){
        this.close()
      },
      initData(userid){
        this.loadSelectedUser(userid)
          .then(() => {
            console.log(this.user);
            this.firstname = this.user.firstname;
            this.lastname  = this.user.lastname;
            this.username  = this.user.username;
            this.role      = this.user.role;
          })
      },
      loadRoleNames(){
        const promise = apiLoadRoleNames().pipe(tap( () => {} )).toPromise();
        promise.then((result) => {
          this.roleNames = result
        })
      }
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        if(to.name === Routes.ROUTE_EDIT_USER && to.params.userid){
          vm.initData(to.params.userid)
        }
        vm.loadRoleNames();
      });
    }
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .form.new-patient{
    @include make-grid-cols(150px 1fr, space(m));

    & > div:first-child{
      @extend %flex-col, %align-items-center;
    }

    .form__row--x{
      max-width: 80%;
    }
  }

</style>
